import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { ITrade } from '../interface/trade/ITrade';
import ITradeBasicInfo from '../interface/trade/ITradeBasicInfo';
import IQueryTradesBasicInfo from '../queryStrings/IQueryTradesBasicInfo';
import IWorkflowBasicInfo from '../interface/trade/IWorkflowBasicInfo';
import { IRequestSignaturePending } from '../interface/trade/IRequestSignaturePending';
import { PendingQueryTypeEnum } from '../enum/PendingQueryTypeEnum';
import { IContractDocument } from '../interface/trade/ContractDocument/IContractDocument';

enum TradeSearchServiceEnum {
  getBasicInfo = '/basic',
  getConsorcieiBasicInfo = '/consorciei/basic',
  getPenddingSinaturesAndTransferAdministrator = '/document/transfer/signature/pending/administrator?',
  getPendingSignature = '/document/signature/pending',
  getTradeDetail = '/detail?',
  getTradeConvenioDetail = '/detail-convenio?',
  searchTrades = '/filter',
  requestSignaturePending = '/request-pending-signature',
  disbursementReady = '/disbursement-ready-basic-info?',
  disbursementAwaiting = 'disbursement-awaiting-basic-info',
  disbursementReject = 'disbursement-reject-basic-info'
}

export default class TradeSearchService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, '/trade/search');
  }

  public getTradesContractsPendingSignature = async (
    data
  ): Promise<IContractDocument[]> => {
    return this.POST(TradeSearchServiceEnum.getPendingSignature, data);
  };

  public getTradesPenddingSignatureTransferAdministrator = async (
    data,
    queryType: PendingQueryTypeEnum
  ): Promise<IWorkflowBasicInfo> =>
    await this.POST(
      `${TradeSearchServiceEnum.getPenddingSinaturesAndTransferAdministrator
      }queryType=${queryType}`,
      data
    );

  public getTradesBasicInfo = async (
    queryString: IQueryTradesBasicInfo
  ): Promise<IWorkflowBasicInfo> =>
    await this.POST(`${TradeSearchServiceEnum.getBasicInfo}`, queryString);

  public getConsorcieiTradesBasicInfo = async (
    queryString: IQueryTradesBasicInfo
  ): Promise<IWorkflowBasicInfo> =>
    await this.POST(`${TradeSearchServiceEnum.getConsorcieiBasicInfo}`, queryString);

  public getTradesDisbursementBasicInfo = async (
    status: string
  ): Promise<IWorkflowBasicInfo> =>
    await this.GET(
      TradeSearchServiceEnum.disbursementReady + 'status=' + status
    );

  public getTradeDetail = async (tradeId: number): Promise<ITrade> =>
    await this.GET(TradeSearchServiceEnum.getTradeDetail + 'id=' + tradeId);
  public getTradeConvenioDetail = async (tradeId: number): Promise<ITrade[]> =>
    await this.GET(
      TradeSearchServiceEnum.getTradeConvenioDetail +
      'tradeConvenioId=' +
      tradeId
    );
  public searchTrades = async (query: string): Promise<ITradeBasicInfo[]> =>
    await this.POST(TradeSearchServiceEnum.searchTrades, { query });
  public requestSignaturePending = async (
    requestSignaturePending: IRequestSignaturePending
  ) =>
    await this.POST(
      TradeSearchServiceEnum.requestSignaturePending,
      requestSignaturePending
    );
}



// WEBPACK FOOTER //
// ./src/services/api/TradeSearch.service.ts